import { createContext, useCallback, useContext, useLayoutEffect, useState } from 'react';

export const BrowseStateContext = createContext(null);

// 快照属于浏览器历史中的一次访问，同一地址的新访问不会沿用旧筛选。
export const useBrowseState = (name, initialValue) => {
  const entry = useContext(BrowseStateContext);
  const restored = Boolean(entry?.values.has(name));
  const [value, setValue] = useState(() => restored ? entry.values.get(name)
    : typeof initialValue === 'function' ? initialValue() : initialValue);
  useLayoutEffect(() => { entry?.values.set(name, value); }, [entry, name, value]);
  return [value, setValue, restored];
};

export const useSyncBrowsePost = () => {
  const entry = useContext(BrowseStateContext);
  return useCallback((postId, post) => {
    for (const page of entry?.entries?.values() || []) {
      for (const [name, items] of page.values) {
        if (!name.startsWith('discovery:') || !name.endsWith(':items')) continue;
        page.values.set(name, post === null ? items.filter(item => String(item.id) !== String(postId))
          : items.map(item => String(item.id) === String(postId) ? { ...item, ...post } : item));
      }
    }
  }, [entry]);
};
